import React, { useContext } from 'react';
import { testimonialsData } from '../data/testimonialsData.js';
import Tilt from 'react-parallax-tilt';
import { themeContext } from '../context/Theme'
import { useTranslation } from 'react-i18next';
import withScrollReveal from '../animattion/withScrollReveal.jsx';

const Testimonials = () => {

  const { dark } = useContext(themeContext);
  const { t } = useTranslation();


  return (
    <div id='Testimonials' className='h-auto w-auto md:pt-10'>
      <p className='text-center text-[2rem] font-bold'> {t('Testimonials')} </p>
      <div className='py-6 w-full flex flex-col justify-center flex-wrap  md:flex-row'>

        {
          testimonialsData.map((testimonData) => (
            <Tilt key={testimonData.id} className={`z-10 h-auto w-auto p-8 flex flex-col justify-center items-center  md:w-[20rem] rounded-3xl hover:shadow-2xl hover:shadow-blue border-2 border-black ${dark ? 'bg-dark_gray' : 'bg-gray-200 hover:shadow-black'}`}>

              <p className='text-justify my-4'>{t(testimonData.translationKey + ".desc")}</p>
             
              <div className="flex flex-wrap gap-2 my-4">
                <img src={testimonData.authore}
                  alt={testimonData.name}
                  className='h-14 w-14 rounded-full'
                />
                <div className="flex flex-col justify-center">
                  <p className='text-lg font-medium' >{testimonData.name}</p>
                  <p className='text-sm' >{testimonData.designation}</p>
                </div>

              </div>

            </Tilt>

          ))
        }
      </div>

    </div>
  )
}

export default withScrollReveal(Testimonials);